export default __webpack_public_path__ + "static/media/uploadButton.8353baaa.svg";